import React from 'react/addons';
import mixins from 'ofs/react/mixins';
import {gettext, interpolate} from 'ofs/i18n';

import TextField from 'ofs/react/fields/textfield';
import GuestModel from '../models/guest';
import SelectField from 'ofs/react/fields/selectfield';
import Row from 'ofs/forms/layout/row';
import Column from 'ofs/forms/layout/column';
import PrestayContentSection from 'ofs/apps/bookings/prestay/views/PrestayContentSection';

const messages = {
  CHANGE: gettext('Change'),
  SAVE: gettext('Submit'),
  REMOVE_GUEST: gettext('Remove guest'),
  LEAD_GUEST: gettext('Lead Guest'),
  ADULT: gettext('Adult'),
  ADD_GUEST: gettext('Add another guest'),
  GUEST_N: gettext('Guest %s'),
  FIRST_NAME: gettext('First name'),
  LAST_NAME: gettext('Last name'),
  AGE: gettext('Age'),
  SLEEPS_ONLY: gettext('This home only sleeps %s people. Please contact our reservations team on %s or %s if you want to add more.'), 
  HEADING: gettext('Additional guests'),
  ADDITONAL_GUEST_PROMPT: gettext("To help us get things shipshape for your arrival, please fill in the names and ages of everyone who'll be staying."),
};

module.exports = function(config) {
  const AdditionalGuests = React.createClass({
    mixins: [mixins.BackboneChangeMixin],

    getInitialState() {
      return {
        isValid: false,
      };
    }, 

    handleClick() {
      // Add new guest
      this.props.collection.add(new GuestModel());
    },

    render() {
      const guests = this.props.collection;
      const payload = JSON.stringify(guests.toJSON());

      const guestNodes = guests.map(function (model, index) {
        return <Guest model={model} collection={guests} index={index + 2} key={model.cid}/>;
      });

      const maximum = (guests.length + 1 >= config.sleepsMax);

      return (
        <PrestayContentSection title={messages.HEADING}>
          <p className="ofs-Prestay__ContentIntro">{messages.ADDITONAL_GUEST_PROMPT}</p>
          <table className="ofs-AdditionalGuests">
            <tbody>
              {guestNodes}
            </tbody>
          </table>
            {maximum ?
              <MaximumGuests number={config.sleepsMax}/>
            :
              <p className="u-no-margin">
                <a onClick={this.handleClick}>{messages.ADD_GUEST}</a>
              </p>
            }
          <input type="hidden" value={payload} name="additional_guests"/>
        </PrestayContentSection>
      );
    }
  });

  const Guest = React.createClass({
    getInitialState() {
      let errors = this.props.model.validate() || {};
      return {
        errors: errors,
        editedFields: {}
      };
    },

    handleRemoveClick() {
      // remove guest
      this.props.collection.remove(this.props.model);
    },

    handleFormChange(fieldName) {
      this.state.editedFields[fieldName] = true;
      this.setState({editedFields: this.state.editedFields});

      this.validate();
    },

    validate() {
      this.setState({
        errors: this.props.model.validate() || {}
      });
    },

    handleLifeStageChange(event) {
      this.props.model.set('life_stage', event.target.value);
    },

    render() {
      const {model} = this.props;
      var changeListener = {};
      var errors = model.validate() || {};
      var self = this;
      ["first_name", "last_name", "life_stage"].forEach(function(fieldName){
        changeListener[fieldName] = self.handleFormChange.bind(null, fieldName);
        errors[fieldName] = self.state.editedFields[fieldName] && self.state.errors[fieldName];
      });

      const lifeStagesOptions = config.lifeStages.map((stage) => {
        return { value: stage[0], name: stage[1] };
      });

      return (
        <tr className="ofs-AdditionalGuests__GuestRow">
          <td className="ofs-AdditionalGuests__Cell ofs-AdditionalGuests__Cell--icon">
            <span className="icon-profile ofs-Prestay__HeadIcon ofs-Prestay__HeadIcon--unselectable" />
          </td>
          <td className="ofs-AdditionalGuests__Cell">
            <Row>
              <Column size="third">
                <div className="ofs-Form__Field">
                  <label className="ofs-Form__Label">{messages.FIRST_NAME}</label>
                  <TextField type="text" field="first_name" placeholder={messages.FIRST_NAME} model={model} onChange={changeListener["first_name"]} onBlur={changeListener["first_name"]} error={errors["first_name"]} />
                </div>
              </Column>
               <Column size="third">
                <div className="ofs-Form__Field">
                  <label className="ofs-Form__Label">{messages.LAST_NAME}</label>
                  <TextField type="text" field="last_name" placeholder={messages.LAST_NAME} model={model} onChange={changeListener["last_name"]} onBlur={changeListener["last_name"]} error={errors["last_name"]} />
                </div>
              </Column>
               <Column size="third">
                 <SelectField label={messages.AGE} options={lifeStagesOptions} model={model} field="life_stage" onChange={this.handleLifeStageChange} onBlur={changeListener["life_stage"]} error={errors["life_stage"]} defaultValue={model.get("life_stage") || null} placeholder="Select age"/>
              </Column>
            </Row>
          </td>
          <td className="ofs-AdditionalGuests__Cell ofs-AdditionalGuests__Cell--removeLink">
            <a onClick={this.handleRemoveClick} title="Remove guest">{messages.REMOVE_GUEST}</a>
          </td>
        </tr>
      );
    },
  });

  const MaximumGuests = React.createClass({
    render() {
      return (
        <p>
          {interpolate(
            messages.SLEEPS_ONLY,
            [this.props.number, config.guestServicesEmail, config.guestServicesPhone]
          )}
        </p>
      );
    }
  });

  return AdditionalGuests;
};


/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/apps/bookings/prestay/guests/views/additional-guests.jsx
 **/